import lazyWithPreload from 'config/lazy-with-preloading';
import AuthGuard from 'modules/shared/components/AuthGuard/AuthGuard';
import { useEffect } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';
import InvoiceDetail from './pages/InvoiceDetail/InvoiceDetail';

const LiveBilling = lazyWithPreload(() => import('./pages/LiveBilling/LiveBilling'));
// const InvoiceDetail = lazyWithPreload(() => import('./pages/InvoiceDetail/InvoiceDetail'));

const LiveBillingRouter = () => {
    useEffect(() => {
        LiveBilling.preload();
        // InvoiceDetail.preload();
    }, []);

    const routes = useRoutes([
        {
            path: '/',
            element: (
                <AuthGuard hasPermissions={['account']}>
                    <LiveBilling />
                </AuthGuard>
            ),
        },
        {
            path: 'invoices/:date',
            element: (
                <AuthGuard hasPermissions={['account']}>
                    <InvoiceDetail />
                </AuthGuard>
            ),
        },
        {
            path: '*',
            element: <Navigate replace to="/404" />,
        },
    ]);

    return routes;
};

export default LiveBillingRouter;
